document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.stores').forEach((stores) => {
    const buttons = stores.querySelectorAll('[data-store-trigger]');
    const panels = stores.querySelectorAll('[data-store-panel]');
    const select = stores.querySelector('.stores__select');

    function activateStore(index) {
      buttons.forEach((button) => {
        button.classList.toggle(
          'is-active',
          button.dataset.storeTrigger === String(index)
        );
      });

      panels.forEach((panel) => {
        panel.classList.toggle(
          'hidden',
          panel.dataset.storePanel !== String(index)
        );
      });

      if (select) {
        select.value = index;
      }
    }

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        activateStore(button.dataset.storeTrigger);
      });
    });

    if (select) {
      select.addEventListener('change', () => {
        activateStore(select.value);
      });
    }

    // initialize first store
    activateStore(0);
  });
});